import { HttpErrorResponse } from '@angular/common/http';
import { AdjustmentService } from '../../../../shared/services/adjustments/adjustment.service';
import { UsersService } from '../../../../shared/services/common/users.service';
import { Component, Input, OnInit } from '@angular/core';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { Utility } from 'src/app/shared/utility';

@Component({
  selector: 'app-corresponding-view',
  templateUrl: './corresponding-view.component.html',
  styleUrls: ['./corresponding-view.component.css']
})
export class CorrespondingViewComponent implements OnInit {
  gridData = [];

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.getCorrespondingDetails(dataItem);
    }
  }

  constructor(
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
  }

  getCorrespondingDetails(dataItem: any) {
    this.notificationService.setUpLoading(true);
    const empData = {
      Ssn: this.usersService.encrypt(dataItem.ssn, 'post'), LocationCode: dataItem.locationCode,
      EmployerId: dataItem.employeeId, PayPeriodEndDate: Utility.formatDate(dataItem.payPeriodEndDate)
    }
    const inputData = {
      userInfo: this.usersService.UserInfo(), employmentData: empData
    };
    this.adjustmentService.getCorrespondingAdjDetails(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        if (response.data) {
          response.data.forEach((element: any) => {
            element.payPeriodEndDate = new Date(element.payPeriodEndDate);
            element.formatAmount = Utility.checkNegativeAmount(element.contributionAmount);
            element.payrollType = 'Payroll';
          });
          this.gridData = response.data;
          if (this.gridData && this.gridData.length === 0) {
            this.gridData.unshift({
              fiscalYear: '--', payPeriodEndDate: null, contributionAmount: null, hoursWorked: '--', standardHours: '--',
              percentage: '--', actualAnnualCompensation: null, actualEarnableCompensation: null, payrollType: 'Payroll'
            });
          }
          dataItem.contributionAmount = dataItem.employeeContribution;
          dataItem.percentage = dataItem.percentFullTime;
          this.gridData[1] = dataItem;
        }
      } else if (response && response.statusCode === 204) {
        this.gridData = [];
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

}
